import React from 'react'
import { EnvelopeFill, Facebook, GeoAltFill, Instagram, Linkedin, Mailbox, Pinterest, Twitter, Youtube } from 'react-bootstrap-icons'
import { Link } from 'react-router-dom'
import { Col, Row } from 'reactstrap'
import FooterLogo from '../assets/images/FooterLogo.webp'
import { useLanguage } from '../contexts/LanguageContext'

const Footer = () => {
    const { t } = useLanguage();
    return (
        <>
        <div id='website-responsive' className='mt-4' style={{ overflow: '' }}>
            <div className='left-padding8rem1 right-padding8rem1 py-5' style={{ backgroundColor: '#2F2E2A' }}>
                <Row className=''>
                    <Col md='12' lg='4' className=''>
                        <div className='d-md-flex justify-content-md-center justify-content-lg-start'>
                            <img src={FooterLogo} alt='' width='250px' className='' />
                        </div>
                        <div className='pt-lg-5 pe-md-5 pe-lg-0 py-4 py-lg-0'>
                            <p className='fs-ss-16 text-mulish fw-500 text-white'>
                                {t('footer.description')}
                            </p>
                        </div>
                    </Col>

                    <Col md='12' lg='4' className='d-md-flex justify-content-md-start justify-content-lg-center pb-4 pb-lg-0'>
                        <div className=''>
                            <div className='text-ss-primary'>
                                <h3 className='fs-ss-32 text-philos fw-700 ' style={{ color: '#FE9B1F' }}>
                                    {t('footer.services')}
                                </h3>
                            </div>
                            <div className=''>
                                <div className=''>
                                    <Link to='/services/app-development' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('services.appDevelopment')}
                                        </p>
                                    </Link>
                                </div>
                                <div className=''>
                                    <Link to='/services/web-development' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('services.webDevelopment')}
                                        </p>
                                    </Link>
                                </div>
                                <div className=''>
                                    <Link to='/services/healthcare-solutions' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('services.healthcareSolutions')}
                                        </p>
                                    </Link>
                                </div>
                                <div className=''>
                                    <Link to='/services/graphic-designing' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('services.graphicDesigning')}
                                        </p>
                                    </Link>
                                </div>
                                <div className=''>
                                    <Link to='/services/search-engine-optimization' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('services.seo')}
                                        </p>
                                    </Link>
                                </div>
                                <div className=''>
                                    <Link to='/services/ppc-marketing' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('services.ppcMarketing')}
                                        </p>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </Col>

                    <Col md='12' lg='4' className='d-md-flex justify-content-md-start justify-content-lg-center ps-lg-4'>
                        <div className=''>
                            <div className='text-ss-primary'>
                                <h3 className='fs-ss-32 text-philos fw-700 ' style={{ color: '#FE9B1F' }}>
                                    {t('footer.quickLinks')}
                                </h3>
                            </div>
                            <div className=''>
                                <div className=''>
                                    <Link to='testimonials' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('footer.testimonials')}
                                        </p>
                                    </Link>
                                </div>
                                <div className=''>
                                    <Link to='/terms-and-conditions' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('footer.termsConditions')}
                                        </p>
                                    </Link>
                                </div>
                                <div className=''>
                                    <Link to='/impressum' className='' style={{ textDecoration: 'none' }}>
                                        <p className='fs-ss-16 text-mulish mb-1 fw-500 text-white'>
                                            {t('impressum.title')}
                                        </p>
                                    </Link>
                                </div>

                                <div className='text-ss-primary mt-md-4 mt-4 mb-md-3 mb-3'>
                                    <h3 className='fs-ss-32 text-philos fw-700 ' style={{ color: '#FE9B1F' }}>
                                        {t('contact.getInTouch')}
                                    </h3>
                                </div>
                                <div className=''>
                                    <div className='d-flex mb-1'>
                                        <a href='mailto: info@itjunction.de' className='' style={{ textDecoration: 'none' }}>
                                        <div className='d-flex align-items-center'>
                                            <EnvelopeFill className='me-2 fs-ss-16' style={{ color:'#FE9B1F'}}/>
                                            <p className='fs-ss-16 text-mulish mb-0 fw-500 text-white'>
                                                info@itjunction.de
                                            </p>
                                            </div>
                                        </a>
                                    </div>
                                    <div className='d-flex'>
                                        <span className=''>
                                            <div className='d-flex align-items-center'>
                                            <GeoAltFill className='me-2 fs-ss-16' style={{ color:'#FE9B1F'}} />
                                            <p className='fs-ss-16 text-mulish mb-0 fw-500 text-white'>
                                                Germany
                                            </p>
                                            </div>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
        <section className="container-fluid py-2 text-white fs-ss-15 text-center" style={{backgroundColor:"#030a0e"}}>
            <div className="row justify-content-evenly">
                <div className="col-11 col-lg-5 text-lato">
                {t('footer.copyright')}
                </div>
                <div className="col-11 col-lg-5 text-center">
                </div>
            </div>
        </section>
        </>
    )
}

export default Footer